import { ScrollingNumberCounter } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

import { ANIMATION_TIMINGS, LAYOUT, SCORE_COLOR } from "../constants";

interface ScoreDisplayProps {
  /**
   * The starting score value
   */
  startScore: number;
  /**
   * The current end score to animate to
   */
  currentEndScore: number;
  /**
   * Whether the counter should be animating
   */
  isAnimating: boolean;
}

export function ScoreDisplay(props: ScoreDisplayProps) {
  const { startScore, currentEndScore, isAnimating } = props;

  // When animating, animate from startScore to currentEndScore
  // When not animating, show the currentEndScore statically
  const startValue = isAnimating ? startScore : currentEndScore;
  const endValue = currentEndScore;

  return (
    <Box
      sx={{
        transform: `scale(${LAYOUT.SCORE_DISPLAY_SCALE})`,
        transformOrigin: "center",
        paddingY: 8,
      }}
    >
      <ScrollingNumberCounter
        startValue={startValue}
        endValue={endValue}
        duration={ANIMATION_TIMINGS.SCORE_ANIMATION_DURATION_MS}
        variant="h1"
        color={SCORE_COLOR}
      />
    </Box>
  );
}
